/*global jQuery, window */

/**
 * Message
 *
 * @class Message
 * @constructor
 * @param {object} options
 * @param {function} callback
 */

export const Message = function (options, callback) {
  "use strict";
  var self = this,
      _events = {
        visibleChanged: [],
        closeClicked: []
      },
      _visible,
      initialize;

  self.options = options;
  self.options.events = self.options.events || {};

  /*******************************************************************************************************************/
  /* Local Methods and Event handlers */

  /* Prepares the side list */
  initialize = function () {
    if (!self.options.container) {
      self.options.mapContainer = $(self.options.mapContainer);
      var $parent = self.options.mapContainer.parent();
      // Create container for all sources
      self.options.container = $parent.find(".js-map-message-container");
      if (self.options.container.length === 0) {
        $parent.append('<div class="notification-container js-map-message-container absolute-centering"></div>');
        self.options.container = $parent.find(".js-map-message-container");
      }
    }

    if (self.options.events.closeClicked) {
      self.onCloseClicked(self.options.events.closeClicked);
    }

    // Call function at the end
    if (callback) {
      callback();
    }
  };

  /*******************************************************************************************************************/
  /* Public Properties and Methods */

  /**
   * Visible flag
   * Boolean flag to show/hide side list.
   *
   * @method setVisible
   * @type {boolean}
   */
  self.setVisible = function (flag) {
    if (_visible !== flag) {
      _visible = flag;
      if (_visible === true) {
        self.options.container.removeClass('hide').show(); // Put animations here
      } else {
        if (!self.options.container.hasClass('hide')) {
          // Remove click event from button and empty content
          jQuery(self.container)
            .find(".close")
            .unbind("click")
            .end()
            .find(".action")
            .unbind("click");
          self.options.container.addClass('hide').empty();
        }
        self.options.container.hide(); // Put animations here
      }

      // Change event
      jQuery.each(_events.visibleChanged, function (x, callback) {
        callback(_visible);
      });
    }
  };

  /**
   * Visible flag
   * Boolean flag to show/hide side list.
   *
   * @method getVisible
   * @type {boolean}
   */
  self.getVisible = function () {
    return _visible;
  };

  /**
   * Hides Side List from display
   *
   * @method hide
   * @return {undefined}
   */
  self.hide = function () {
    self.setVisible(false);
  };


  /**
   * Shows Message on Display
   *
   * @method show
   * @param {object} params
   * @param {number} params.count Number of properties delivered to the map
   * @param {number} params.total Total number of properties available for the area
   * @param {string} params.message Text/HTML message
   * @param {bool} params.showAdvanced Show Advanced Button with event
   * @return {undefined}
   */
  self.show = function (params) {
    if (params) {
      var html ='<section class="overlay-message notification"><div class="ra ra-close close-overlay"></div><p>'+( params.message)+'</p></section>';

      // Hide existing notification
      self.setVisible(false);

      self.options.container.append(html);
      // Calculate position
      if (params.pos === undefined) {

        /*if ((params.total === 0 && params.count === 0) || params.message !== undefined) {
        // map centre
        params.pos = self.options.mapContainer.position();
        params.pos.top = params.pos.top + ((self.options.mapContainer.height() / 2) - (self.options.container.height() / 2));
        params.pos.left = params.pos.left + ((self.options.mapContainer.width() /2 ) - (self.options.container.width() / 2));
        self.options.container.removeClass('shadow');
        } else { // sidelist
        self.resize();
        params.pos = {};
        self.options.container.addClass('shadow');
        }

        // Set notification position
        if (params.pos.top >= 0) {
        pos.top = params.pos.top.toString() + "px";
        }
        if (params.pos.left > 0) {
        pos.left = params.pos.left.toString() + "px";
        }
        self.options.container.css(pos);*/

        // Wire up events
        // Close
        jQuery(self.options.container)
          .find(".close-overlay")
          .click(function (e) {
            jQuery.each(_events.closeClicked, function (x, callback) {
              if (callback) {
                callback({
                  message: html
                });
              }
            });
            self.hide();
            e.stopPropagation();
          }).end();
        self.setVisible(true);
      }
    }
  };

  /*******************************************************************************************************************/
  /* Events */

  /**
   * Event occurs when extension visible flag is changed
   *
   * @method onVisibleChanged
   */
  self.onVisibleChanged = function (callback) {
    self.options.utils.addToEvents(callback, _events.visibleChanged);
  };

  /**
   * Event occurs when notification close button is clicked
   *
   * @method onCloseClicked
   */
  self.onCloseClicked = function (callback) {
    self.options.utils.addToEvents(callback, _events.closeClicked);
  };


  /* Initializes this extension */
  initialize();
};



// WEBPACK FOOTER //
// ./shared_critical/components/message.js